module.exports = __webpack_public_path__ + "9c386b25897c682689d62e5a2d90f4f7.fbx";